<script>

export default {
  name: 'RulesOfUserConduct'
}
</script>

<template lang="pug" src="./RulesOfUserConduct.pug"></template>
